<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @task="taskFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.name"
              placeholder="请输入名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                :value="1"
                label="草稿"
              />
              <el-option
                :value="2"
                label="发布"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @remove="removeFun(arguments)"
        @publish="publishFun(arguments)"
        @back="backFun(arguments)"
        @adjust="adjustFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 调整-->
    <adjust-dialog
      :data-id="id"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAdjustVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 新增 修改
import AdjustDialog from './components/adjustDialog'
// 数据请求
import { loadAppConsumerIntegralExchangeSettingListDataApi, loadAppConsumerIntegralExchangeSettingExportDataApi, saveOrUpdateAppConsumerIntegralExchangeSettingApi, findAppConsumerIntegralExchangeSettingCountByConditionApi } from '@/api/appConsumerIntegralExchangeSetting'

export default {
  name: 'AppConsumerIntegralExchangeSetting',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    AdjustDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_integral_exchange_setting_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_integral_exchange_setting_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_del'],
            prop: 'remove',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_publish'],
            prop: 'publish',
            label: '发布',
            method: 'publish'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_back'],
            prop: 'back',
            label: '退回',
            method: 'back'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_publish'],
            prop: 'adjust',
            label: '调整',
            method: 'adjust'
          },
          {
            permissionSigns: ['app_user_integral_exchange_setting_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            name: '',
            sort: '',
            status: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      dialogAdjustVisible: false,
      // 待办
      todoList: [
        {
          permissionSigns: ['app_user_integral_exchange_setting_publish'],
          label: '待发布奖品设置',
          method: 'task',
          count: 0
        }
      ]
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 's.province_name', label: '省区', width: 120 },
      { prop: 'activityName', filterColumn: 'b.name', label: '活动名称', width: 160 },
      { prop: 'appletTypeStr', filterColumn: 's.applet_type', filterValue: 'appletType', label: '所属小程序', width: 120, filterArray: [{ label: '渝享荟', value: 1 }, { label: '循香会友', value: 2 }] },
      { prop: 'sortStr', filterColumn: 's.sort', filterValue: 'sort', label: '类型', width: 120, filterArray: [{ label: '扫码积分', value: 1 }, { label: '扫码抽奖', value: 2 }] },
      { prop: 'name', filterColumn: 's.name', label: '兑换名称', width: 160 },
      { prop: 'startDateStr', filterColumn: 's.start_date', label: '开始日期', width: 140, isBetween: true },
      { prop: 'endDateStr', filterColumn: 's.end_date', label: '结束日期', width: 140, isBetween: true },
      { prop: 'integral', filterColumn: 's.integral', label: '兑换积分', width: 120 },
      { prop: 'winRateStr', filterColumn: 's.win_rate', filterValue: 'winRate', label: '中奖率', width: 120 },
      { prop: 'amount', filterColumn: 's.amount', label: '兑换中奖数量', width: 140 },
      { prop: 'leftAmount', filterColumn: 's.left_amount', label: '剩余数量', width: 120 },
      { prop: 'statusStr', filterColumn: 's.status', filterValue: 'status', label: '状态', width: 120, filterArray: [{ label: '草稿', value: 1 }, { label: '发布', value: 2 }] },
      { prop: 'remark', filterColumn: 's.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 's.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 's.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerIntegralExchangeSettingListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      let params = { status: 1 }
      findAppConsumerIntegralExchangeSettingCountByConditionApi(params).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    // 待发布
    taskFun () {
      this.masterList.tableQuery.search.name = ''
      this.masterList.tableQuery.search.sort = ''
      this.masterList.tableQuery.search.status = 1
      this.loadTableData()
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增奖品设置'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在草稿状态，不能修改',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改奖品设置'
    },
    // 修改
    adjustFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 2) {
        this.$message({
          message: '数据不在发布状态，不能调整',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogAdjustVisible = !this.dialogAdjustVisible
      this.dialogAddEditViewTitle = '调整奖品设置'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看奖品设置'
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在草稿状态，不能作废',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该奖品设置？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerIntegralExchangeSettingApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 发布
    publishFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在草稿状态，不能发布',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定发布该奖品设置？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerIntegralExchangeSettingApi({ id: args[0].id, isPublish: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 退回
    backFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 2) {
        this.$message({
          message: '数据不在发布状态，不能退回',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定退回该奖品设置？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerIntegralExchangeSettingApi({ id: args[0].id, isBack: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerIntegralExchangeSettingExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
